import React from "react";
import { useState, useEffect } from "react";
import { BiEdit, BiSave } from "react-icons/bi";
import { Button, Input } from "reactstrap";

export default function EditActionRow({ action, handleSave, index }) {
  const [inputValue, setInputValue] = useState(action);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    setInputValue(action);
  }, [action]);

  return (
    <div className="d-flex align-items-center">
      <Input
        type="textarea"
        className="border-none"
        style={{ width: "100%" }}
        onChange={(e) => {
          setInputValue(e.target.value);
          handleSave(e.target.value);
        }}
        value={inputValue}
        rows={3}
      />
    </div>
  );
}
